import styles from './styles.module.scss'
import { Separator } from 'components/Separator/Separator'
import { FC, PropsWithChildren } from 'react'

export const ContainerHeader: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.content}>{children}</div>
      <Separator />
    </div>
  )
}
